import { ParticipantListReportTemplateData } from "./ParticipantListReportTemplateData";
import { backgroundLogo, headerLogo } from "../constants/PdfReports";
import { formatDate } from "../core/Utility";

export const ParticipantListReportImportTemplate = (data: ParticipantListReportTemplateData) => {

    return {
        background: [
            {
                image: backgroundLogo,
                width: 580,
                alignment: 'center',
                absolutePosition: {x: 0, y: 200}
            }
        ],
        header: [],
        footer: [],
        content: [
            {
                image: headerLogo,
                alignment: 'center',
                margin:[0,5,0,0]
            },
            {
                text: `Lista učesnika`,
                style: 'title',
                margin:[0,20,0,5]
            },
            {
                "canvas": [{
                    "lineColor": "gray",
                    "type": "line",
                    "x1": 0,
                    "y1": 0,
                    "x2": 515,
                    "y2": 0,
                    "lineWidth": 1
                }],
                margin:[0,5,0,10]
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['13%','13%','25%','12%','22%','15%'],
                    body: [
                        [
                            {
                                columns: [
                                    {
                                        width: '100%',
                                        text: `Ime: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        width: '100%',
                                        text: `Prezime: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `Događaj: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `Tip: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `Pravno lice: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    }
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `Telefon: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                        ]
                    ]
                }
            },
            {
                "canvas": [{
                    "lineColor": "gray",
                    "type": "line",
                    "x1": 0,
                    "y1": 0,
                    "x2": 515,
                    "y2": 0,
                    "lineWidth": 1
                }],
                margin:[0,5,0,10]
            },
            data.reportData?.map((item) => {
                return ({
                    width: '50%',
                    layout: 'noBorders',
                    table: {
                        widths: ['13%','13%','25%','12%','22%','15%'],
                        body: [
                            [
                                {
                                    columns: [
                                        {
                                            text: `${item.firstName ?? ''}`,
                                            style: 'textLeft',
                                            bold: false,
                                            margin:[0,0,0,0]
                                        },
                                    ]
                                },
                                {
                                    columns: [
                                        {
                                            text: `${item.lastName ?? ''}`,
                                            style: 'textLeft',
                                            bold: false,
                                            margin:[0,0,0,0]
                                        },
                                    ]
                                },
                                {
                                    columns: [
                                        {//@ts-ignore
                                            text: `${item?.event?.name}`,
                                            style: 'textLeft',
                                            bold: false,
                                            margin:[0,0,0,0]
                                        },
                                    ]
                                },
                                {
                                    columns: [
                                        {
                                            text: `${item.type}`,
                                            style: 'textLeft',
                                            bold: false,
                                            margin:[0,0,0,0]
                                        },
                                    ]
                                },
                                {
                                    columns: [
                                        {
                                            text: `${item.companyName}`,
                                            style: 'textLeft',
                                            margin:[0,0,0,0]
                                        }
                                    ]
                                },
                                {
                                    columns: [
                                        {//@ts-ignore
                                            text: `${item.phone}`,
                                            style: 'textLeft',
                                            margin:[0,0,0,0]
                                        }
                                    ]
                                },
                            ]
                        ]
                    }
                }
            )}),
            {
                "canvas": [{
                    "lineColor": "gray",
                    "type": "line",
                    "x1": 0,
                    "y1": 0,
                    "x2": 515,
                    "y2": 0,
                    "lineWidth": 1
                }],
                margin:[0,5,0,10]
            },
        ],
        styles: {
            title: {
                fontSize: '14',
                alignment: 'center',
                margin:[0,20,0,10],
                bold: true
            },
            textLeft: {
                fontSize: '10',
                alignment: 'left',
            },
            textRight: {
                fontSize: '10',
                alignment: 'right',
            }
        }
    }
}